export const OverflowMenuHelpComponentModule = angular
    .module('app.components.pageHeader.overflowMenuHelp', [])
    .component('overflowMenuHelp', {
        template: `
            <md-menu-item class="overflow-menu-help">
                <md-button
                    ng-href="https://help.volusion.com/"
                    target="_blank"
                    aria-label="{{'HELP_ACTIONS.DOCS' | translate}}"
                >
                    <span translate="HELP_ACTIONS.DOCS"></span>
                </md-button>
            </md-menu-item>
        `
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/pageHeader/overflowMenu/overflowMenuHelp.js